import { render, staticRenderFns } from "./MetricsBar.vue?vue&type=template&id=319677c6"
import script from "./MetricsBar.vue?vue&type=script&lang=js"
export * from "./MetricsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports